import { setLocale, strings } from "@/locales";

const LANGUAGE_CACHE_KEY = "teams-app-language";

beforeEach(() => {
  localStorage.clear();
  jest.restoreAllMocks();
});

describe("strings", () => {
  it("returns a string for a given key", () => {
    expect(typeof strings("Loader")).toBe("string");
  });
});

describe("setLocale", () => {
  it("warns and does nothing when no locale is provided", () => {
    const warn = jest.spyOn(console, "warn").mockImplementation(() => {});
    setLocale("");
    expect(warn).toHaveBeenCalledWith("No locale provided!");
  });

  it("warns when no matching locale is found", () => {
    const warn = jest.spyOn(console, "warn").mockImplementation(() => {});
    setLocale(9999, "id");
    expect(warn).toHaveBeenCalledWith("No locale found!", 9999);
  });

  it("changes the language and caches it when found by id", () => {
    setLocale(1, "id");
    expect(localStorage.getItem(LANGUAGE_CACHE_KEY)).toBe("fr");
  });

  it("changes the language when found by culture", () => {
    setLocale("en-US", "culture");
    expect(localStorage.getItem(LANGUAGE_CACHE_KEY)).toBe("en");
  });

  it("skips changing when the language is already set", () => {
    const debug = jest.spyOn(console, "debug").mockImplementation(() => {});
    setLocale("fr-FR", "culture");
    setLocale("fr-FR", "culture");
    expect(debug).toHaveBeenCalled();
  });
});
